// EWODiscripencyReducer.js
import {
  FETCH_EWO_DISCRIPENCY_REQUEST,
  FETCH_EWO_DISCRIPENCY_SUCCESS,
  FETCH_EWO_DISCRIPENCY_FAILURE,
  FETCH_IWO_WITHOUT_EWO_REQUEST,
  FETCH_IWO_WITHOUT_EWO_SUCCESS,
  FETCH_IWO_WITHOUT_EWO_FAILURE,
  FETCH_EWO_WITHOUT_INVOICE_REQUEST,
  FETCH_EWO_WITHOUT_INVOICE_SUCCESS,
  FETCH_EWO_WITHOUT_INVOICE_FAILURE,
} from "../constants/EWODiscripencyConstants";

const initialState = {
  // original date-based query (kept as-is)
  loading: false,
  data: [],
  error: null,

  // IWO Without EWO
  iwoWithoutEwoLoading: false,
  iwoWithoutEwoData: [],
  iwoWithoutEwoError: null,

  // EWO Without Invoice
  ewoWithoutInvoiceLoading: false,
  ewoWithoutInvoiceData: [],
  ewoWithoutInvoiceError: null,
};

const EWODiscripencyReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Original ──
    case FETCH_EWO_DISCRIPENCY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_EWO_DISCRIPENCY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_EWO_DISCRIPENCY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── IWO Without EWO ──
    case FETCH_IWO_WITHOUT_EWO_REQUEST:
      return { ...state, iwoWithoutEwoLoading: true, iwoWithoutEwoError: null };
    case FETCH_IWO_WITHOUT_EWO_SUCCESS:
      return { ...state, iwoWithoutEwoLoading: false, iwoWithoutEwoData: action.payload, iwoWithoutEwoError: null };
    case FETCH_IWO_WITHOUT_EWO_FAILURE:
      return { ...state, iwoWithoutEwoLoading: false, iwoWithoutEwoError: action.payload };

    // ── EWO Without Invoice ──
    case FETCH_EWO_WITHOUT_INVOICE_REQUEST:
      return { ...state, ewoWithoutInvoiceLoading: true, ewoWithoutInvoiceError: null };
    case FETCH_EWO_WITHOUT_INVOICE_SUCCESS:
      return { ...state, ewoWithoutInvoiceLoading: false, ewoWithoutInvoiceData: action.payload, ewoWithoutInvoiceError: null };
    case FETCH_EWO_WITHOUT_INVOICE_FAILURE:
      return { ...state, ewoWithoutInvoiceLoading: false, ewoWithoutInvoiceError: action.payload };

    default:
      return state;
  }
};

export default EWODiscripencyReducer;